export function formatWeight(p) {
    const grams = Number(p?.weightGrams || 0);

    if (!grams) return '—';

    if (grams >= 1000) {
        const kg = grams / 1000;
        const txt = Number.isInteger(kg)
            ? String(kg)
            : kg.toFixed(2).replace(/\.?0+$/, '');

        return `${txt} кг`;
    }

    return `${grams} г`;
}